import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';

@Component({
  selector: 'app-expandable-panel',
  templateUrl: './expandable-panel.component.html',
  styleUrls: ['./expandable-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpandablePanelComponent {
  @Input() themeless = true;
  @Input() inline = true;
  @Input() expanded = false;
  @Input() disabled = false;
  @Input() toggleIcon: string;
  @Output() opened = new EventEmitter();
  @Output() closed = new EventEmitter();

  @ViewChild('expansionPanel') expansionPanel: MatExpansionPanel;

  toggle(): void {
    if (!this.disabled) {
      this.expansionPanel.toggle();
    }
  }
}
